import {useEffect, useState} from 'react';

import _ from 'lodash';

/**
 * React hook to get the number of columns to dynamically render
 *  depending on given HtmlElement's ref width
 * @param {*} elementRef
 * @param {Function} getNumBlocks
 * @return {Number}
 */
export function useNumberOfColumns(elementRef, getNumBlocks) {
  const [currBlocks, setCurrBlocks] = useState(getNumBlocks(elementRef));

  // will execute frame after element ref is first mounted - use to initialize the
  // number of columns
  useEffect(() => {
    setCurrBlocks(getNumBlocks(elementRef));
  }, [elementRef, getNumBlocks]);

  useEffect(() => {
    const debouncedResizeHandler = _.debounce(() => {
      const blocks = getNumBlocks(elementRef);
      setCurrBlocks(blocks);
    }, 25); // 25ms
    window.addEventListener('resize', debouncedResizeHandler);
    return () => window.removeEventListener('resize', debouncedResizeHandler);
  }, [currBlocks, elementRef, getNumBlocks]);
  return currBlocks;
}
